import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Tabs } from 'antd';
import Researcher from './Researcher';
import Department from './Department';
import PITeam from './PITeam';
import SideNav from '../SideNav';
import { saveParams } from '../../../actions/departmentActions';

const { TabPane } = Tabs;

class CommentInfo extends Component {
    state = {
        panes: [{
            title: '科室点评',
            key: 'department',
            content: null,
        }, {
            title: 'PI团队点评',
            key: 'piTeam',
            content: null,
        }, {
            title: '研究者点评',
            key: 'researcher',
            content: null,
        }],
        activeKey: 'department',
    }

    componentDidMount() {
        const { params: { departmentName } } = this.props;
        if (departmentName) {
            this.updatePanes();
        } else {
            this.leave(false);
        }
    }

    updatePanes = () => {
        const { panes, activeKey } = this.state;
        const { params: { isAdd, hospitalDepartmentId } } = this.props;
        let RenderContent = null;
        if (activeKey == 'department') {
            RenderContent = Department;
        } else if (activeKey == 'piTeam') {
            RenderContent = PITeam;
        } else if (activeKey == 'researcher') {
            RenderContent = Researcher;
        }
        panes.forEach(item => {
            if (item.key == activeKey) {
                item.content = <RenderContent isAdd={isAdd} hospitalDepartmentId={hospitalDepartmentId} />;
            } else {
                item.content = null;
            }
        });
        this.setState({ panes });
    }

    handleTabsChange = (activeKey) => {
        this.setState({ activeKey }, () => {
            this.updatePanes();
        });
    }

    leave = (feedBack) => {
        const { params: { showCommentLog = false } } = this.props;
        this.props.saveParams({ feedBack, showCommentLog });
        window.history.go(-1);
    }

    render() {
        const { panes, activeKey } = this.state;
        const { params: { hospitalName = '', departmentName = '' } } = this.props;
        return (
            <div className="content">
                <SideNav selectKey='departmentDetail' />
                <div className="main">
                    <div style={{ overflow: 'hidden', marginBottom: 20 }}>
                        <div style={{ float: 'left', marginLeft: 10 }}>
                            <i
                                className="icon iconfont"
                                style={{ marginRight: 4, fontSize: '20px', color: '#1296DB'}}
                            >&#xe65b;</i>
                            {hospitalName}
                            <span className="ant-divider" />
                            {departmentName}
                        </div>
                        <div style={{ float: 'right', marginRight: 10, color: '#1296DB', cursor: 'pointer' }} onClick={() => this.leave(true)}>
                            <i
                                className="icon iconfont"
                                style={{ marginRight: 4, fontSize: '20px' }}
                            >&#xe63d;</i>
                            返回
                        </div>
                    </div>
                    <Tabs type="card" activeKey={activeKey} onChange={this.handleTabsChange}>
                        {panes.map(pane => <TabPane tab={pane.title} key={pane.key}>{pane.content}</TabPane>)}
                    </Tabs>
                </div>  
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { departmentState: { params = {} } } = state;
    return {
        params,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: params => dispatch(saveParams(params)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CommentInfo);


// WEBPACK FOOTER //
// ./src/components/hospital/commentInfo/index.js